module.exports = __webpack_public_path__ + "static/05-617ff1e59be92eff731992eb5c5da909.png";